import React, { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { IoMdClose } from 'react-icons/io';
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "./FormRenderer";
import { useAppDispatch } from "../../../../redux/hook";
import { getCompanyEmployerSubContractors } from "../../../../redux/features/inputModule.slice";

function AdditionalFiltersInputUploads(this: any, { data, selectedFilters, onSubmit, onCancel }: any) {
    const [filter, setFilter] = useState<any>({ hideButtons: true, ...selectedFilters });
    const [employers, setEmployers] = useState<any[]>([]);
    const [employerLocations, setEmployerLocations] = useState<any[]>([]);
    const [employerSubContractors, setEmployerSubContractors] = useState<any[]>([]);
    const [employerSubContractorsLocations, setEmployerSubContractorsLocations] = useState<any[]>([]);

    const [employerId, setEmployerId] = useState<string>('');
    const [employerLocationId, setEmployerLocationId] = useState<string>('');
    const [subContractorId, setSubContractorId] = useState<string>('');
    const [subContractorLocationId, setSubContractorLocationId] = useState<string>('');
    const [formKey, setFormKey] = useState<number>(0);
    const [isLoadingEmployers, setIsLoadingEmployers] = useState<boolean>(false);
    const [isLoadingEmployerLocations, setIsLoadingEmployerLocations] = useState<boolean>(false);
    const [isLoadingSubContractors, setIsLoadingSubContractors] = useState<boolean>(false);
    const [isLoadingSubContractorLocations, setIsLoadingSubContractorLocations] = useState<boolean>(false);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (data) {
          fetchEmployers();
        }
    }, [data]);

    useEffect(() => {
      const { employer, employerLocation, subContractor, subContractorLocation} = selectedFilters || {};
      if (employer) {
        fetchEmployers();
        fetchEmployerLocations();
      }
      if (employerLocation) {
        fetchSubContractors();
      }
      if (subContractor) {
        fetchSubContractorLocations();
      }
    }, [selectedFilters]);

    useEffect(() => {
      if (employerId) {
        fetchEmployerLocations();
      }
    }, [employerId]);

    useEffect(() => {
      if (employerLocationId) {
        fetchSubContractors();
      }
    }, [employerLocationId]);

    useEffect(() => {
      if (subContractorId) {
        fetchSubContractorLocations();
      }
    }, [subContractorId]);

    function onEmployerChange(value: any) {
      const _filter = { ...filter, employer: value, employerLocation: null, subContractor: null, subContractorLocation: null };
      setFilter(_filter);
      setEmployerId(value ? value.value : '');
      setEmployerLocationId('');
      setSubContractorId('');
      setSubContractorLocationId('');
    }

    function onEmployerLocationChange(value: any) {
      const _filter = { ...filter, employerLocation: value, subContractor: null, subContractorLocation: null };
      setFilter(_filter);
      setEmployerLocationId(value ? value.value : '');
      setSubContractorId('');
      setSubContractorLocationId('');
    }

    function onEmployerSubContractorChange(value: any) {
      const _filter = { ...filter, subContractor: value, subContractorLocation: null };
      setFilter(_filter);
      setSubContractorId(value ? value.value : '');
      setSubContractorLocationId('');
    }

    function onEmployerSubContractorLocationChange(value: any) {
      const _filter = { ...filter, subContractorLocation: value };
      setFilter(_filter);
      setSubContractorLocationId(value ? value.value : '');
    }

    function getPayload(payloadType: 'employer' | 'subContractor' | 'employerLocation' | 'subContractorLocation') {
      const { establishmentType, company, associate_company, location} = data;
      const _payload: any = {
        filters: {
          establishment_type_eq: establishmentType || '',
          company_id_eq: company || '',
          associate_company_id_eq: associate_company || '',
          company_location_mapping_id_eq: location || ''
        },
        per: 5000,
        page: 1,
        "includeCentral": true
      };
      if (payloadType === 'employer') {
        _payload.include = {
          employer: {
            only: ['id', 'name']
          }
        };
      } else if (payloadType === 'employerLocation') {
        _payload.filters['employer_id_eq'] = filter.employer ? filter.employer.value : null;
        _payload.include = {
          employer_location: {
            only: ['id', 'location_name']
          }
        };
      } else if (payloadType === 'subContractor') {
        _payload.filters['employer_id_eq'] = filter.employer ? filter.employer.value : null;
        _payload.filters['employer_location_id_eq'] = filter.employerLocation ? filter.employerLocation.value : null;
        _payload.include = {
          sub_contractor: {
            only: ['id', 'name']
          }
        };
      } else if (payloadType === 'subContractorLocation') {
        _payload.filters['employer_id_eq'] = filter.employer ? filter.employer.value : null;
        _payload.filters['employer_location_id_eq'] = filter.employerLocation ? filter.employerLocation.value : null;
        _payload.filters['sub_contractor_id_eq'] = filter.subContractor ? filter.subContractor.value : null;
        _payload.include = {
          sub_contractor_location: {
            only: ['id', 'location_name']
          }
        };
      }
      return _payload;
    }

    function fetchEmployers() {
        const payload = getPayload('employer');
        setIsLoadingEmployers(true);
        dispatch(getCompanyEmployerSubContractors(payload)).then((response: any) => {
            if (response && response.payload && response.payload.data && response.payload.data.items) {
              const items = response.payload.data.items || [];
              const tempEmployers: any[] = [];
              items.forEach((x: any) => {
                if (x.employer_id && x.employer) {
                  if (!tempEmployers.some((y: any) => y.id === x.employer.id)) {
                    tempEmployers.push(x.employer);
                  }
                }
              });
              setEmployers(tempEmployers);
            } else {
                setEmployers([]);
            }
            setIsLoadingEmployers(false);
        });
    }

    function fetchEmployerLocations() {
        const payload = getPayload('employerLocation');
        setIsLoadingEmployerLocations(true);
        dispatch(getCompanyEmployerSubContractors(payload)).then((response: any) => {
            if (response && response.payload && response.payload.data && response.payload.data.items) {
              const items = response.payload.data.items || [];
              const tempLocations: any[] = [];
              items.forEach((x: any) => {
                if (x.employer_location_id && x.employer_location) {
                  if (!tempLocations.some((y: any) => y.id === x.employer_location.id)) {
                    tempLocations.push(x.employer_location);
                  }
                }
              });
              setEmployerLocations(tempLocations);
            } else {
                setEmployerLocations([]);
            }
            setIsLoadingEmployerLocations(false);
        });
    }

    function fetchSubContractors() {
        const payload = getPayload('subContractor');
        setIsLoadingSubContractors(true);
        dispatch(getCompanyEmployerSubContractors(payload)).then((response: any) => {
            if (response && response.payload && response.payload.data && response.payload.data.items) {
              const items = response.payload.data.items || [];
              const tempSubContractors: any[] = [];
              items.forEach((x: any) => {
                if(x.sub_contractor_id && x.sub_contractor){
                  if (!tempSubContractors.some((y: any) => y.id === x.sub_contractor.id)) {
                    tempSubContractors.push(x.sub_contractor);
                  }
                }
              });
              setEmployerSubContractors(tempSubContractors);
            } else {
                setEmployerSubContractors([]);
            }
            setIsLoadingSubContractors(false);
        });
    }

    function fetchSubContractorLocations() {
        const payload = getPayload('subContractorLocation');
        setIsLoadingSubContractorLocations(true);
        dispatch(getCompanyEmployerSubContractors(payload)).then((response: any) => {
            if (response && response.payload && response.payload.data && response.payload.data.items) {
              const items = response.payload.data.items || [];
              const tempLocations: any[] = [];
              items.forEach((x: any) => {
                if (x.sub_contractor_location_id && x.sub_contractor_location) {
                  if (!tempLocations.some((y: any) => y.id === x.sub_contractor_location.id)) {
                    tempLocations.push(x.sub_contractor_location);
                  }
                }
              });
                setEmployerSubContractorsLocations(tempLocations);
            } else {
                setEmployerSubContractorsLocations([]);
            }
            setIsLoadingSubContractorLocations(false);
        });
    }

    const schema: any = {
        fields: [
            {
                component: componentTypes.SELECT,
                name: 'employer',
                label: 'Employer',
                options: employers.map((x: any) => ({
                    label: x.name,
                    value: x.id
                })),
                initialValue: filter.employer,
                isMulti: false,
                isLoading: isLoadingEmployers,
                onChange: onEmployerChange            },
            {
                component: componentTypes.SELECT,
                name: 'employerLocation',
                label: 'Employer Location',
                options: employerLocations.map((x: any) => ({
                    label: x.location_name,
                    value: x.id
                })),
                initialValue: filter.employerLocation,
                isMulti: false,
                isDisabled: !filter.employer,
                isLoading: isLoadingEmployerLocations,
                onChange: onEmployerLocationChange            },
            {
                component: componentTypes.SELECT,
                name: 'subContractor',
                label: 'Sub Contractor',
                options: employerSubContractors.map((x: any) => ({
                    label: x.name,
                    value: x.id
                })),
                initialValue: filter.subContractor,
                isMulti: false,
                isDisabled: !filter.employerLocation,
                isLoading: isLoadingSubContractors,
                onChange: onEmployerSubContractorChange            },
            {
                component: componentTypes.SELECT,
                name: 'subContractorLocation',
                label: 'Sub Contractor Location',
                options: employerSubContractorsLocations.map((x: any) => ({
                    label: x.location_name,
                    value: x.id
                })),
                initialValue: filter.subContractorLocation,
                isMulti: false,
                isDisabled: !filter.subContractor,
                isLoading: isLoadingSubContractorLocations,
                onChange: onEmployerSubContractorLocationChange            }
        ]
    }

    function isInvalid() {
        return !filter.employer;
    }

    function clearFilter() {
      const emptyPayload = {
        employer_id_eq: "",
        employer_location_id_eq: "",
        sub_contractor_id_eq: "",
        sub_contractor_location_id_eq: "",
      };
      onSubmit({ payload: emptyPayload, selectedFilters: {} });
      onCancel();
    }

    function clearAndClose() {
      onCancel();
    }

    function search() {
      const { employer, employerLocation, subContractor, subContractorLocation} = filter;
      const _payload: any = {};
      if (employer) {
          _payload.employer_id_eq = employer.value;
      } else {
        _payload.employer_id_eq = "";
      }

      if (employerLocation) {
          _payload.employer_location_id_eq = employerLocation.value;
      } else {
        _payload.employer_location_id_eq = "";
      }

      if (subContractor) {
          _payload.sub_contractor_id_eq = subContractor.value;
      } else {
        _payload.sub_contractor_id_eq = "";
      }

      if (subContractorLocation) {
          _payload.sub_contractor_location_id_eq = subContractorLocation.value;
      } else {
          _payload.sub_contractor_location_id_eq = "";
      }
      onSubmit({ payload: _payload, selectedFilters: filter });
      onCancel();
    }

    return (
        <Modal show={true} backdrop="static" animation={false} centered size="lg" className="performer-filters-modal">
            <Modal.Header closeButton={true}>
                <Modal.Title className="bg d-flex align-items-center justify-content-between w-100">
                  <div className="fs-5 fw-semibold">                   
                    More Filters
                  </div>
                  <div>
                    <IoMdClose
                      onClick={clearAndClose}
                      style={{ cursor: 'pointer', marginRight: '8px', verticalAlign: 'middle' }}
                    />
                  </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex justify-content-start">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                <FormRenderer key={formKey} FormTemplate={FormTemplate}
                                    initialValues={filter}
                                    componentMapper={ComponentMapper}
                                    schema={schema}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="d-flex gap-2 flex-nowrap">
                <button className="button-secondary m-0 w-50" onClick={clearFilter}>Clear All</button>
                <button className="button-primary m-0 w-50" onClick={search} disabled={isInvalid()}>Submit</button>
            </Modal.Footer>
        </Modal>
    )
}

export default AdditionalFiltersInputUploads;
